import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes/Routes';

function AppContent() {
  return <Routes />;
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
